import React, { useState } from 'react';
import HelpSheet from './HelpSheet';
import './ErrorToast.css';

// Standard error display (DCN-027 trial — Page 5-11 only for now, not
// yet wired into every other formError/alert() call site in the app).
// Tier 1 (`message`) always shown; Tier 2 (`tier2_text`) reveals on
// click, growing the toast itself, not the page behind it; Tier 3 opens
// the existing HelpSheet slideover rather than navigating away from
// whatever the user was doing.
//
// `error` is the raw error-response shape errorResponse() returns
// ({ message, tier2_text, article_slug }) — or any plain
// { message } for a client-side validation string that never hit the
// backend, which just renders Tier 1 with no reveal affordance.
//
// `anchored` picks which of the two positions under trial this is:
// - false (default) — position: fixed, bottom-right of the *viewport*.
//   Same screen position always, regardless of scroll position or which
//   screen's layout triggered it — but on a wide monitor can land well
//   outside normal eye-track.
// - true — position: absolute, bottom-right of the nearest
//   position: relative ancestor (the page's own content box, placed
//   near BrowseNav). Reads as part of the page rather than floating
//   viewport chrome, but only visible once that part of the page is
//   scrolled into view — the opposite trade-off.
function ErrorToast({ error, onDismiss, anchored }) {
  const [expanded, setExpanded] = useState(false);
  const [helpOpen, setHelpOpen] = useState(false);

  if (!error) return null;

  return (
    <>
      <div className={`error-toast ${anchored ? 'error-toast--anchored' : 'error-toast--fixed'}`} role="alert">
        <div className="error-toast-row">
          <span className="error-toast-message">{error.message}</span>
          <button type="button" className="error-toast-close" onClick={onDismiss} aria-label="Dismiss">×</button>
        </div>
        {error.tier2_text && (
          <>
            <button type="button" className="error-toast-toggle" onClick={() => setExpanded((v) => !v)}>
              {expanded ? 'Hide details ▴' : 'Why? ▾'}
            </button>
            {expanded && (
              <div className="error-toast-detail">
                <p>{error.tier2_text}</p>
                {error.article_slug && (
                  <button type="button" className="error-toast-manual-link" onClick={() => setHelpOpen(true)}>
                    Manual ↗
                  </button>
                )}
              </div>
            )}
          </>
        )}
      </div>
      {error.article_slug && (
        <HelpSheet open={helpOpen} onOpenChange={setHelpOpen} articleSlug={error.article_slug} />
      )}
    </>
  );
}

export default ErrorToast;
